import { Toast } from "antd-mobile";

import { getStrFun } from "./util";
import { getClientAuthToken, resetLoginReloadCount, setSessionAuthToken, promptLoginFailReload } from "./authStorage";

import { userInit, getInfo } from "../api/user";
import { getOrderStatus, createOrder } from "../api/recharge";
import { reportLead } from "./pixelReport";

/** 与 localStorage my_token 同步的内存全局，便于调试或非请求场景读取 */
export function setGlobalMyToken(token) {
  try {
    if (typeof window !== "undefined") {
      window.__my_token__ = token == null ? "" : String(token);
    }
    setSessionAuthToken(token);
  } catch (e) {}
}

class MainService {
  constructor() {
    this.throttle = this.throttleFn(); // 节流
    this.debounce = this.debounceFn(); // 防抖
  }

  // 用户进入登录 静默授权 bol: 是否强制登录
  async loginFunSilent(bol = false) {
    try {
      let localusr = localStorage.getItem("user_info") || "{}";
      localusr = JSON.parse(localusr);
      const hasToken = !!getClientAuthToken();
      if (!bol && localusr && localusr.openid && hasToken) {
        return "success";
      }
      await this.getUserInit();
      if (!getClientAuthToken()) {
        throw new Error("init failed");
      }
      return "success";
    } catch (error) {
      console.log("loginFunSilent error", error);
      throw error;
    }
  }

  // 用户进入登录 静默授权（init 成功即返回，不等待 getInfo）
  async loginFunSilentV2() {
    try {
      await this.getUserInit();
      if (!getClientAuthToken()) {
        throw new Error("init failed");
      }
      return "success";
    } catch (error) {
      console.log("loginFunSilentV2 error", error);
      throw error;
    }
  }

  // 个人页点击登录
  async ttLoginFun() {
    try {
      await this.getUserInit();
      if (!getClientAuthToken()) {
        throw new Error("init failed");
      }
      return "success";
    } catch (error) {
      console.log("ttLoginFun error", error);
      throw error;
    }
  }

  /**
   * H5 匿名登录：POST /User/init，不传参。
   * init 成功后异步拉 getInfo，不阻塞返回。
   * - 首次：返回 token，前端落库后后续请求带头
   * - 已有身份：可能不返回 token，沿用本地已有 token
   */
  async getUserInit() {
    try {
      const res = await userInit();
      if (res && res.token) {
        // 首次匿名注册（服务端返回新 token）时上报 Meta Pixel Lead
        reportLead();
        localStorage.setItem("my_token", res.token);
        setGlobalMyToken(res.token);
        resetLoginReloadCount();
        this.getInfoFun();
        return res;
      }

      // 已有身份：init 不回 token，本地已有 token 则视为成功
      if (getClientAuthToken()) {
        resetLoginReloadCount();
        this.getInfoFun();
        return res || {};
      }

      promptLoginFailReload();
      return null;
    } catch (error) {
      promptLoginFailReload();
      return null;
    }
  }

  // 获取用户信息
  async getInfoFun() {
    try {
      console.log("getInfoFun.....执行了");
      const userInfo = await getInfo({}, { hideToastDialg: true });
      if (userInfo && userInfo.user_info && userInfo.user_info.user_id) {
        console.log("userInfo.user_info.show_check_subscription_issue", userInfo.show_check_subscription_issue);
        userInfo.user_info["show_check_subscription_issue_front"] = userInfo.show_check_subscription_issue;
        userInfo.user_info["show_user_center_vip_front"] = userInfo.show_user_center_vip;
        localStorage.setItem("user_info", JSON.stringify(userInfo.user_info));
        return userInfo;
      } else {
        Toast.show({ content: getStrFun("logfail", "Login failed") });
        return null;
      }
    } catch (error) {
      Toast.show({content: (error && error.message) || getStrFun("errtips", "Something is wrong. Please retry later!")});
      return null;
    }
  }
  // 创建订单：返回 sessionID 供 Evonet Drop-in 拉起收银台（不在此阻塞播放页）
  creatOrder(data, forcebol = false) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.loginFunSilent(!!forcebol);
        if (!getClientAuthToken()) {
          reject({ msg: "hasnotlogined", iscreatordererr: true });
          return;
        }
        const res = await createOrder(data || {});
        const sid = res && (res.sessionID || res.sessionId || res.session_id);
        if (!sid) {
          reject({
            msg: "no_session",
            message: getStrFun("errtips", "Something is wrong. Please retry later!"),
            iscreatordererr: true,
            ...(res || {}),
          });
          return;
        }
        resolve(res || {});
      } catch (error) {
        const errObj = error && typeof error === "object" ? error : {};
        reject({
          ...errObj,
          iscreatordererr: true,
          code: error && error.code,
          msg: (error && (error.msg || error.message)) || "creat_order_fail",
        });
      }
    });
  }
  sleep(time) {
    return new Promise(async (resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  }
  // 轮询
  checkOrderRet(order_id, checkRetentionflag = 0, iserrorcnum = 0) {
    let returnObj = {};
    return new Promise(async (resolve, reject) => {
      try {
        const handleCheck = async () => {
          let res = {};
          let params = { order_id: order_id };
          if (iserrorcnum) {
            params["errNo"] = iserrorcnum;
          }
          res = await getOrderStatus(params);
          if (res.status === true || res.status === 1 || res.status === "1") {
            returnObj = res;
            return true;
          } else {
            return false;
          }
        };
        let counter = 0;
        const maxAttempts = 6;
        let quitCheck = false;
        while (counter < maxAttempts && !quitCheck) {
          counter++;
          const isSuccess = await handleCheck();
          if (isSuccess) {
            quitCheck = true;
            resolve(returnObj);
          } else if (counter === maxAttempts) {
            reject({ msg: "overtimes", order_id, checkRetentionflag }); // 超出轮询次数
          }
          await this.sleep(500);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * 节流适用场景：表单提交
   * @param {function} handler 进行防抖的函数
   * @param {number} wait 等待时间ms
   */
  throttleFn() {
    var lastTime = 0;
    return function (handler, wait = 1000) {
      var nowTime = new Date().getTime();
      if (nowTime - lastTime > wait) {
        handler && handler();
        lastTime = nowTime;
      }
    };
  }

  /**
   * 防抖适用场景：搜索框
   * @param {function} handler 进行防抖的函数
   * @param {number} delay 等待时间ms
   */
  debounceFn() {
    var timer = null;
    return function (handler, delay = 1000) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        handler && handler();
      }, delay);
    };
  }
}
const mainService = new MainService(); // 将实例赋值给变量
export default mainService; // 导出该实例
